<div class="inner-content" ridangoAppTrapFocus>
    <div
        class="bottom-0 left-0 right-0 top-0 !flex flex items-center dark:rounded-2xl dark:border-2 dark:border-solid dark:border-contrast-yellow">
        <div class="flex-column flex h-full w-full rounded-2xl bg-white text-base">
            <div class="relative flex items-center border-b border-solid p-4">
                <div class="w-10"></div>
                <p class="flex-1 text-center font-semibold leading-none">{{ 'REMOVE_PAYMENT_METHOD' | translate }}</p>
                <!-- ORB has different text size because it uses a different font and this causes button shift -->
                <button
                    class="flex items-center justify-center !leading-none text-grey-zambezy"
                    [attr.aria-label]="'CLOSE' | translate"
                    (click)="cancel()"
                    mat-icon-button>
                    <mat-icon>close</mat-icon>
                </button>
            </div>

            <div class="box-border flex-1 overflow-y-auto border-b border-solid px-4">
                <div
                    class="flex-align-center flex w-full gap-4 border-b border-solid p-2 last:border-0"
                    *ngFor="let card of availableSavedPaymentCards">
                    <img class="h-7 dark:filter-yellow" src="{{ env.PAYMENT_PORTAL_URL + card.imageUrl }}" alt="" />
                    <div class="flex-1">
                        <p class="text-base font-bold">{{ card.type | translate }}</p>
                        <p class="text-base">**** **** **** {{ card.lastFourDigits }}</p>
                    </div>
                    <ion-button class="next-button" (click)="omMethodDelete(card)" fill="clear">
                        <ion-icon
                            class="var-app-light:text-primary-danger orb-app-light:text-primary-danger text-primary dark:text-contrast-yellow"
                            src="{{ assetsPath$ | async }}/img/purchase-flow-v2/cart/icon-delete.svg"></ion-icon>
                    </ion-button>
                </div>
            </div>

            <div class="m-4">
                <div class="flex">
                    <button
                        class="var-app-light:text-contrast-black vl-app-light:bg-[var(--btn-primary-color)] vl-app-light:text-black orb-app-light-dark:bg-[var(--btn-primary-color)] orb-app-light-dark:text-contrast-black h-14 w-full rounded-lg bg-secondary font-bold text-white shadow-md dark:bg-contrast-yellow dark:text-contrast-black"
                        (click)="deletePaymentMethodsConfirm()"
                        type="submit">
                        {{ 'REMOVE_PAYMENT_METHOD_CONFIRM' | translate }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
